import { CommonFrontOfficeCrumbs } from './breadcrumb';

export const RetrieveIdCardCrumbs = [
  ...CommonFrontOfficeCrumbs,
  {
    name: 'Recupero Cartellini CIE',
    path: '/sportello/recupero-cie',
  },
];
